import { mediaCommerceApi } from './api-slice';

export const useMediaCommerce = (id: number) => {
  const { data: mediaCommerce, isLoading, error } = mediaCommerceApi.useGetMediaCommerceQuery(id, { refetchOnMountOrArgChange: true });
  return {
    collection: mediaCommerce,
    isLoading,
    error
  }
}